import slice from './reducer'
import * as selectors from './selectors'

export { selectors }
export const {
  openEmailCompose,
  closeEmail,
  setEmailCollapsed,
  emailSendStarted,
  emailSent,
  emailSendFailed,
  emailReplyOrForwardStarted,
  emailReplyOrForwardLoaded,
  emailReplyOrForwardFailed,
  emailDraftCreated,
  emailDraftUpdateStarted,
  emailDraftUpdated,
  emailAttachmentsSaveStarted,
  emailAttachmentsSaved,
  emailAttachmentsSaveFailed,
  emailReceiptRequested,
  emailReceiptLoaded,
  emailReceiptFailed,
  emailSendingSucceeded,
  emailSendingFailed,
  emailSendingStatusRefetched,
  setEmailCreateContact,
  emailContactCreateStarted,
  emailContactCreated,
  emailContactCreateFailed,
  emailRecipientAdded,
  emailRecipientsAdded,
  emailRecipientRemoved,
  emailRecipientsLoadingStarted,
  emailRecipientsLoadingFinished,
  resetEmail,
} = slice.actions
export const SendEmailReducer = slice.reducer
